import { useCallback } from "react";
import { useSearchTabs } from "../contexts/SearchTabsContext";

export const useSearchTabsController = () => {
  const {
    tabs,
    activeTab,
    activeTabId,
    setActiveTabId,
    addTab,
    removeTab,
    updateActiveTabFormData,
    setActiveTabResults,
    setActiveTabLoading,
    mergeTabResults,
    setTabLoading,
    setActiveTabSort,
    setTabSort,
    setTabSearchId,
    setActiveTabSearchId,
  } = useSearchTabs();

  const setFormValues = useCallback(
    (values) => {
      updateActiveTabFormData(values);
    },
    [updateActiveTabFormData],
  );

  const setResults = useCallback(
    (results, meta) => {
      setActiveTabResults(results, meta);
    },
    [setActiveTabResults],
  );

  const setLoading = useCallback(
    (loading) => {
      setActiveTabLoading(loading);
    },
    [setActiveTabLoading],
  );

  const setTabLoadingById = useCallback(
    (tabId, loading) => {
      setTabLoading(tabId, loading);
    },
    [setTabLoading],
  );

  const setSortForActiveTab = useCallback(
    (sort) => {
      setActiveTabSort(sort);
    },
    [setActiveTabSort],
  );

  const setSortForTab = useCallback(
    (tabId, sort) => {
      setTabSort(tabId, sort);
    },
    [setTabSort],
  );

  const mergeResultsByTab = useCallback(
    (tabId, results, meta) => {
      mergeTabResults(tabId, results, meta);
    },
    [mergeTabResults],
  );

  return {
    tabs,
    activeTab,
    activeTabId,
    setActiveTabId,
    addTab,
    removeTab,
    setFormValues,
    setResults,
    setLoading,
    setTabLoadingById,
    mergeResultsByTab,
    setSortForActiveTab,
    setSortForTab,
    setTabSearchId,
    setActiveTabSearchId,
  };
};

